import { render, staticRenderFns } from "./InputQuizset.vue?vue&type=template&id=2581bb7b&scoped=true&"
import script from "./InputQuizset.vue?vue&type=script&lang=js&"
export * from "./InputQuizset.vue?vue&type=script&lang=js&"
import style0 from "./InputQuizset.vue?vue&type=style&index=0&id=2581bb7b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2581bb7b",
  null
  
)

export default component.exports